/**
 * 全局常量
 * - 编译期不变的字面量统一放这里
 * - 命名规范：UPPER_SNAKE_CASE
 */

/** 默认分页大小 */
export const PAGE_SIZE = 20

/** 接口默认超时时间（毫秒） */
export const REQUEST_TIMEOUT = 15_000

/** 最大重试次数 */
export const MAX_RETRY = 3

/** Token 在 storage 中的 key */
export const TOKEN_KEY = 'CSC_TOKEN'

/** Refresh Token 在 storage 中的 key */
export const REFRESH_TOKEN_KEY = 'CSC_REFRESH_TOKEN'

/** 设备 ID（用于 Refresh 绑定，防机器人） */
export const DEVICE_ID_KEY = 'CSC_DEVICE_ID'

/** 用户信息在 storage 中的 key */
export const USER_INFO_KEY = 'CSC_USER_INFO'

/** 系统信息在 storage 中的 key */
export const SYSTEM_INFO_KEY = 'CSC_SYSTEM_INFO'

/** 接口缓存默认 TTL（秒） */
export const REQUEST_CACHE_TTL = 60

/** 默认头像 */
export const DEFAULT_AVATAR = '/static/icons/logo.png'
